import React, { useState, useEffect } from 'react';
import { getTablesApi } from './Api'
import Draggable from 'react-draggable'; // The default
import CanvasMap from './CanvasMap'

const SeatLayout = (props) => {

    const floorId = props.match.params.floorId
    const floorName = props.match.params.name
    const [loading, setLoading] = useState(false);
    const [tableArray, setTableArray] = useState([]);


    useEffect(() => {
        getTables()
        return () => {

        };
    }, [0]);

    const getTables = async () => {
        setLoading(true)

        const res = await getTablesApi(floorId);
        console.log('Data is', res.data.data)
        setTableArray(res.data.data)
        setLoading(false)
    }

    return (
        <div className="w-full min-h-screen flex ">


            <div className="bg-indigo-100 min-h-screen p-4 w-15%">
                <h5 className="w-full text-center">Tables for : <b>{floorName}</b></h5>


                <div className="flex flex-col p-2">
                    {
                        tableArray.map(table => {
                            return (
                                <div className="flex-col border-2 border-gray-400 px-2 py-2">
                                    <p>{table.tableName}</p>
                                    <p>{table.capacity}</p>
                                </div>
                            )
                        })
                    }
                </div>


            </div>











            {/* //layout container goes here  */}

            <div className=" min-h-screen p-4 w-85%  cursor-default">


                {/* <Draggable
                    axis="both"
                    handle=".handle"
                    defaultPosition={{ x: 0, y: 0 }}
                    position={null}
                    grid={[25, 25]}
                    scale={1}
                >
                    <div className="handle cursor-pointer">Table 1</div>
                </Draggable> */}


                <CanvasMap/>

            </div>








        </div>
    );
}

export default SeatLayout;
